import ShipTypeRange from "@/model/ShipTypeRange"
import Ship from "@/model/Ship"
import { shipTypeCodes } from "@/utils/constants"
import Configuration from "@/model/Configuration"

class CalcRequiredEEXIService {
    public static calcRequiredEEXI(ship: Ship, configuration?: Configuration) {
        const logElement = new Array<string>()

        let gt_to_use = ship.gt
        let dwt_to_use = ship.dwt
        if (configuration) {
            CalcRequiredEEXIService.addToLog(
                "calcRequiredEEXI para buque " + ship.name + " y la configuración " + configuration.name,
                logElement
            )
            console.log(ship)
            console.log(configuration)
            if (configuration.modified_gt && configuration.modified_gt != 0) {
                gt_to_use = configuration.modified_gt
            }
            if (configuration.modified_dwt && configuration.modified_dwt != 0) {
                dwt_to_use = configuration.modified_dwt
            }
        } else {
            CalcRequiredEEXIService.addToLog("calcRequiredEEXI para buque " + ship.name, logElement)
            console.log(ship)
        }

        const reductionFactor = CalcRequiredEEXIService.calcRedutionFactor(ship, gt_to_use, dwt_to_use, logElement)
        CalcRequiredEEXIService.addToLog("calcRequiredEEXI - ReductionFactor " + reductionFactor, logElement)

        const rlv = CalcRequiredEEXIService.calcReferenceLineValue(ship, gt_to_use, dwt_to_use, logElement)
        CalcRequiredEEXIService.addToLog("calcRequiredEEXI - Reference Line Value " + rlv, logElement)

        let requiredEEXI = (1 - reductionFactor / 100) * rlv
        requiredEEXI = Math.round(requiredEEXI * 1000) / 1000
        CalcRequiredEEXIService.addToLog("calcRequiredEEXI - required EEXI " + requiredEEXI, logElement)

        requiredEEXI = isFinite(requiredEEXI) ? requiredEEXI : 0

        return { requiredEEXI, logElement }
    }

    public static calc_B(ship, gt_to_use: number, dwt_to_use: number, logElement) {
        CalcRequiredEEXIService.addToLog("calc_B", logElement)
        let result: number = 0

        if (ship.shipType.name === "Container ship") {
            result = Math.min(dwt_to_use, 80000)
        } else if (ship.shipType.name === "Passenger vessels") {
            result = gt_to_use
        } else {
            result = dwt_to_use
        }

        CalcRequiredEEXIService.addToLog("calc_B Result = " + result, logElement)
        return result
    }

    private static getDateToComponent(dateFromFirebase) {
        let date = new Date(Date.UTC(2020, 0, 1))
        if (dateFromFirebase) {
            date = new Date(Date.UTC(1970, 0, 1))
            date.setUTCSeconds(dateFromFirebase ? dateFromFirebase.seconds : 0)
        }
        return date
    }

    public static isEEDIUsingDates(
        keelLaidDownDate: Date,
        contractSignInDate: Date,
        shipDeliveredDate: Date,
        logElement
    ): boolean {
        CalcRequiredEEXIService.addToLog("isEEDI", logElement)
        let result: boolean = false

        CalcRequiredEEXIService.addToLog("isEEDI keelLaidDownDate = " + keelLaidDownDate, logElement)
        CalcRequiredEEXIService.addToLog("isEEDI contractSignInDate = " + contractSignInDate, logElement)
        CalcRequiredEEXIService.addToLog("isEEDI shipDeliveredDate = " + shipDeliveredDate, logElement)

        result = result || (keelLaidDownDate && keelLaidDownDate > new Date(2013, 7, 1))
        result = result || (contractSignInDate && contractSignInDate > new Date(2013, 1, 1))
        result = result || (shipDeliveredDate && shipDeliveredDate > new Date(2015, 7, 1))

        CalcRequiredEEXIService.addToLog("isEEDI Result = " + result, logElement)
        return result == true
    }

    public static calcReferenceLineValue(ship: Ship, gt_to_use: number, dwt_to_use: number, logElement: Array<string>) {
        this.addToLog("calcReferenceLineValue", logElement)
        let result: number = 0

        if (ship.shipType) {
            let a = ship.shipType.a
            const c = ship.shipType.c
            let b = dwt_to_use
            this.addToLog("calcReferenceLineValue. Default values a = " + a + ". b = " + b + ". c = " + c, logElement)

            if (ship.shipType.code === shipTypeCodes.BulkCarrier) {
                if (dwt_to_use > 279000) {
                    this.addToLog("calcReferenceLineValue. BulkCarrier dwt > 279000", logElement)
                    b = dwt_to_use
                }
            } else if (ship.shipType.code === shipTypeCodes.ROROCargo) {
                if (dwt_to_use / gt_to_use < 0.3) {
                    this.addToLog("calcReferenceLineValue. ROROCargo dwt_to_use/gt_to_use < 0.3", logElement)
                    a = Math.pow(dwt_to_use / gt_to_use, -0.7) * 780.36
                }
            } else if (ship.shipType.code === shipTypeCodes.RORO) {
                if (ship.keelLaidDownDate >= new Date(2020)) {
                    this.addToLog("calcReferenceLineValue. RORO keelLaidDownDate > 2020/01/01", logElement)
                    a = 1686.17
                    if (dwt_to_use > 17000) {
                        this.addToLog(
                            "calcReferenceLineValue. RORO keelLaidDownDate > 2020/01/01 y dwt_to_use > 17000",
                            logElement
                        )
                        b = 17000
                    }
                }
            } else if (ship.shipType.code === shipTypeCodes.ROPAX) {
                if (ship.keelLaidDownDate >= new Date(2020)) {
                    this.addToLog("calcReferenceLineValue. ROPAX keelLaidDownDate > 2020/01/01", logElement)
                    a = 902.59
                    if (dwt_to_use > 10000) {
                        this.addToLog(
                            "calcReferenceLineValue. ROPAX keelLaidDownDate > 2020/01/01 and dwt_to_use > 10000",
                            logElement
                        )
                        b = 10000
                    }
                }
            } else if (ship.shipType.code === shipTypeCodes.Passengers) {
                this.addToLog("calcReferenceLineValue. Passengers b = gt", logElement)
                b = gt_to_use
            }
            this.addToLog("calcReferenceLineValue. Default values a = " + a + ". b = " + b + ". c = " + c, logElement)

            result = a * Math.pow(b, -1 * c)
        }
        return result
    }

    public static calcRedutionFactor(ship, gt_to_use: number, dwt_to_use: number, logElement) {
        const findRangeResult = CalcRequiredEEXIService.findAssociatedRange(ship, gt_to_use, dwt_to_use, logElement)
        let y: number = 0

        let valueToUse = dwt_to_use
        if (ship.shipType && ship.shipType.code === shipTypeCodes.Passengers) {
            valueToUse = gt_to_use
        }

        if (findRangeResult.valid) {
            const range = findRangeResult.range
            y = range.Ymin + ((range.Ymax - range.Ymin) * (valueToUse - range.DWTmin)) / (range.DWTmax - range.DWTmin)
            CalcRequiredEEXIService.addToLog(
                "calcRedutionFactor. y = " +
                    y +
                    ". dwt (or gt) = " +
                    valueToUse +
                    ". Ymin = " +
                    range.Ymin +
                    ". Ymax = " +
                    range.Ymax +
                    ". DWTmin = " +
                    range.DWTmin +
                    ". DWTmax = " +
                    range.DWTmax,
                logElement
            )
        } else {
            CalcRequiredEEXIService.addToLog("calcRedutionFactor - Rango no encontrado", logElement)
        }

        return y
    }

    public static findAssociatedRange(ship, gt_to_use: number, dwt_to_use: number, logElement) {
        let validResult = false

        let valueToUse = dwt_to_use
        if (ship.shipType && ship.shipType.code === shipTypeCodes.Passengers) {
            valueToUse = gt_to_use
        }

        let rangeFound = new ShipTypeRange()
        const typeName = ship.shipType ? ship.shipType.name : "no_type"
        CalcRequiredEEXIService.addToLog(
            "Vamos a buscar el rango para el buque de gwt " + dwt_to_use + " y tipo " + typeName,
            logElement
        )
        if (ship.shipType && ship.shipType.ranges) {
            ship.shipType.ranges.forEach((range: ShipTypeRange) => {
                if (range.DWTmin <= valueToUse && valueToUse < range.DWTmax) {
                    CalcRequiredEEXIService.addToLog("Encontrado " + range.DWTmin + " - " + range.DWTmax, logElement)
                    validResult = true
                    rangeFound = range
                }
            })
        }
        return { valid: validResult, range: rangeFound }
    }

    private static addToLog(message: string, logElement: Array<string>) {
        logElement.push(message)
        console.log(message)
    }
}

export default CalcRequiredEEXIService
